import React from 'react';
import { Spinner } from 'react-activity';
import 'react-activity/dist/library.css';

import { ErrorMessage } from './ErrorBoundary';

const Loading = () => {
  return <Spinner />;
};

const Error = ({ error }) => {
  const message = error?.message || 'Unknown Error';

  return <ErrorMessage message={message} />;
};

const exports = { Loading, Error };
export default exports;
